import {
  // Navigation & UI
  Menu,
  X,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  Search,
  Settings,
  MoreHorizontal,
  MoreVertical,
  
  // Actions & Interactions
  Plus,
  Minus,
  Check,
  Copy,
  Edit,
  Trash2,
  Download,
  Upload,
  Share2,
  ExternalLink,
  Link,
  
  // Communication & Social
  Mail,
  MessageSquare,
  Phone,
  Send,
  Share,
  Twitter,
  Linkedin,
  Github,
  Facebook,
  Instagram,
  Youtube,
  
  // Media
  Image,
  Video,
  Play,
  Pause,
  Volume2,
  VolumeX,
  
  // Files & Data
  File,
  FileText,
  Folder,
  Save,
  Database,
  HardDrive,
  
  // Notifications & Alerts
  Bell,
  AlertCircle,
  AlertTriangle,
  Info,
  HelpCircle,
  
  // User & Account
  User,
  Users,
  UserPlus,
  UserMinus,
  Lock,
  Unlock,
  Key,
  
  // Weather & Nature
  Sun,
  Moon,
  Cloud,
  CloudRain,
  Wind,
  
  // Business & Commerce
  CreditCard,
  DollarSign,
  ShoppingCart,
  ShoppingBag,
  Tag,
  
  // Technology & Devices
  Smartphone,
  Tablet,
  Laptop,
  Monitor,
  Wifi,
  Bluetooth,
  Battery,
  
  // Layout & Design
  Layout,
  Columns,
  Grid,
  Maximize,
  Minimize,
  
  // Miscellaneous
  Heart,
  Star,
  Clock,
  Calendar,
  Map,
  Home,
  Building,
  Briefcase,
  Coffee,
  
  // AI & Technology
  Bot,
  Cpu,
  Terminal,
  Code,
  Zap,
  Sparkles,
  Lightbulb,
  Gauge,
  
  // Analytics & Charts
  BarChart,
  LineChart,
  PieChart,
  TrendingUp,
  TrendingDown,
} from 'lucide-react';

export const icons = {
  // Navigation & UI
  menu: Menu,
  close: X,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  arrowUp: ArrowUp,
  arrowDown: ArrowDown,
  search: Search,
  settings: Settings,
  moreHorizontal: MoreHorizontal,
  moreVertical: MoreVertical,

  // Actions & Interactions
  add: Plus,
  remove: Minus,
  check: Check,
  copy: Copy,
  edit: Edit,
  delete: Trash2,
  download: Download,
  upload: Upload,
  share: Share2,
  externalLink: ExternalLink,
  link: Link,

  // Communication & Social
  mail: Mail,
  message: MessageSquare,
  phone: Phone,
  send: Send,
  shareAlt: Share,
  twitter: Twitter,
  linkedin: Linkedin,
  github: Github,
  facebook: Facebook,
  instagram: Instagram,
  youtube: Youtube,

  // Media
  image: Image,
  video: Video,
  play: Play,
  pause: Pause,
  volume: Volume2,
  mute: VolumeX,

  // Files & Data
  file: File,
  fileText: FileText,
  folder: Folder,
  save: Save,
  database: Database,
  storage: HardDrive,

  // Notifications & Alerts
  notification: Bell,
  error: AlertCircle,
  warning: AlertTriangle,
  info: Info,
  help: HelpCircle,

  // User & Account
  user: User,
  users: Users,
  userAdd: UserPlus,
  userRemove: UserMinus,
  lock: Lock,
  unlock: Unlock,
  key: Key,

  // Weather & Nature
  sun: Sun,
  moon: Moon,
  cloud: Cloud,
  rain: CloudRain,
  wind: Wind,

  // Business & Commerce
  creditCard: CreditCard,
  currency: DollarSign,
  cart: ShoppingCart,
  bag: ShoppingBag,
  tag: Tag,

  // Technology & Devices
  smartphone: Smartphone,
  tablet: Tablet,
  laptop: Laptop,
  monitor: Monitor,
  wifi: Wifi,
  bluetooth: Bluetooth,
  battery: Battery,

  // Layout & Design
  layout: Layout,
  columns: Columns,
  grid: Grid,
  maximize: Maximize,
  minimize: Minimize,

  // Miscellaneous
  heart: Heart,
  star: Star,
  clock: Clock,
  calendar: Calendar,
  map: Map,
  home: Home,
  building: Building,
  briefcase: Briefcase,
  coffee: Coffee,

  // AI & Technology
  bot: Bot,
  cpu: Cpu,
  terminal: Terminal,
  code: Code,
  zap: Zap,
  sparkles: Sparkles,
  lightbulb: Lightbulb,
  gauge: Gauge,

  // Analytics & Charts
  barChart: BarChart,
  lineChart: LineChart,
  pieChart: PieChart,
  trendingUp: TrendingUp,
  trendingDown: TrendingDown,
} as const;

export type IconName = keyof typeof icons; 